import React from 'react';
import {
  Reveal, Popup, Button, Container, Divider, Grid, Header, Icon, Image, List, Menu, Segment, Visibility, Table,
} from 'semantic-ui-react';

const AccionesPerfil = (props) => {
  const handleVerPaciente = () => {
    props.router.push(`/pacientes/${props.idPaciente}/perfil`);
  };

  const handleOpenHistoriaClinica = () => {
    props.router.push(`/${props.idPaciente}/historiaClinica/`);
  };

  const handleAgregarEpisodio = () => {
    props.router.push(`/${props.idPaciente}/historiaClinica/nuevoEpisodio`);
  };

  return (
    <Button.Group basic size={props.buttonGroupSize}>

      { props.showVerPaciente
        ? (
          <Popup
            trigger={<Button onClick={handleVerPaciente} icon="magnify" />}
            content="Ver paciente"
            size="tiny"
            position={props.popUpPosition}
          />
        )
        : null}
      {
        props.showHistoriaClinica
          ? (
            <Popup
              trigger={<Button onClick={handleOpenHistoriaClinica} icon="heartbeat" />}
              content="Ver historia clínica"
              size="tiny"
              position={props.popUpPosition}
            />
          )
          : null
      }

      {
        props.showNewEpisodio
          ? (
            <Popup
              trigger={<Button onClick={handleAgregarEpisodio} icon="edit" />}
              content="Agregar nuevo episodio"
              size="tiny"
              position={props.popUpPosition}
            />
          )
          : null
      }

      {
          props.showDelete
            ? (
              <Popup
                trigger={<Button icon="user delete" />}
                content="Desvincular paciente"
                size="tiny"
                position={props.popUpPosition}
              />
            )
            : null
      }

    </Button.Group>
  );
};

AccionesPerfil.defaultProps = {
  showVerPaciente: true,
  showDelete: true,
  showNewEpisodio: true,
  showHistoriaClinica: true,
  popUpPosition: 'bottom center',
  buttonGroupSize: 'huge',
};

export default AccionesPerfil;



// WEBPACK FOOTER //
// ./src/routes/Pacientes/components/AccionesPerfil.js